/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentGame: {
      quest: null,
      character: null,
      characters: [],
      location: null,
      locations: [],
      encounter: null,
      encounters: [],
      discoveredClues: [],
    },
    quests: [],
    characters: [],
    locations: [],
    clues: [],
    encounters: [],
    showLogo: 'false',
  },
  mutations: {
    setShowLogo(state, showLogo) {
      state.showLogo = showLogo;
    },
    setQuests(state, quests) {
      state.quests = quests;
    },
    setCurrentQuest(state, quest) {
      state.currentGame.quest = quest;
      // filter availble characters
      state.currentGame.characters = state.characters;
      // filter available locations and clues
      const { locations } = state;
      locations.forEach((loc) => {
        const clues = state.clues.filter(c => c.location.fields.name === loc.name
          && c.quests.find(q => q.fields.name === quest.name));
        // console.log(`location: ${loc.name} ${clues}`);
        state.currentGame.locations.push({
          name: loc.name,
          clues,
        });
      });
    },
    clearCurrentQuest(state) {
      state.currentGame.quest = null;
      state.currentGame.locations = [];
      state.currentGame.location = null;
      state.currentGame.characters = [];
      state.currentGame.character = null;
      state.currentGame.encounters = [];
      state.currentGame.encounter = null;
      state.currentGame.discoveredClues = [];
    },
    setCharacters(state, characters) {
      state.characters = characters;
    },
    setCurrentCharacter(state, character) {
      state.currentGame.character = character;
      state.encounters.forEach((enc) => {
        if (enc.character.findIndex(c => c.fields.name === character.name) !== -1) {
          state.currentGame.encounters.push(enc);
        }
      });
    },
    clearCurrentCharacter(state) {
      state.currentGame.character = null;
    },
    setLocations(state, locations) {
      state.locations = locations;
    },
    setCurrentLocation(state, location) {
      state.currentGame.location = location;
    },
    clearCurrentLocation(state) {
      state.currentGame.location = null;
    },
    setClues(state, clues) {
      state.clues = clues;
    },
    setEncounters(state, encounters) {
      state.encounters = encounters;
    },
    setCurrentEncounter(state, encounter) {
      state.currentGame.encounter = encounter;
    },
    addDiscoveredClue(state, clue) {
      state.currentGame.discoveredClues.push(clue);
    },
  },
  actions: {
    clearCurrentQuest(context) {
      context.commit('clearCurrentCharacter');
      context.commit('clearCurrentQuest');
    },
    async getGameData(context) {
      const cmsDataAccess = await import(/* webpackChunkName: "cmsData" */ './lib/cmsDataAccess.js');
      // eslint-disable-next-line
      const cmsData = await cmsDataAccess.default().catch(console.error);
      const cmsFieldsMapper = i => i.fields;

      const quests = cmsData.items.filter(i => i.sys.contentType.sys.id === 'quest').map(cmsFieldsMapper);
      context.commit('setQuests', quests);
      const characters = cmsData.items.filter(i => i.sys.contentType.sys.id === 'character').map(cmsFieldsMapper);
      context.commit('setCharacters', characters);
      const locations = cmsData.items.filter(i => i.sys.contentType.sys.id === 'location').map(cmsFieldsMapper);
      context.commit('setLocations', locations);
      const clues = cmsData.items.filter(i => i.sys.contentType.sys.id === 'clue').map(cmsFieldsMapper);
      context.commit('setClues', clues);
      const encounters = cmsData.items.filter(i => i.sys.contentType.sys.id === 'encounter').map(cmsFieldsMapper);
      context.commit('setEncounters', encounters);
    },
  },
});
